export var MESSAGE_STREAMING_REPOSITORY = 'MESSAGE_STREAMING_REPOSITORY';